export const url = "/api/v1.0/upload";

// The file_url is used for the uploads itself, since this works with the TUS protocol
export const file_url = "/api/v1.0/file";